import config from '../../../../config/config';
import { Configuration, StatusesApi } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const statusesApi = new StatusesApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
